/**
 * Обязательная смена временного пароля.
 *
 * Показывается вместо всего интерфейса, пока человек не задаст свой пароль.
 * Иначе временные пароли живут годами и расходятся по перепискам —
 * администратор в итоге знает пароли всей команды, а это лишняя
 * ответственность и лишний риск.
 */
import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

export function ChangePasswordPage() {
  const { user, reload, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== repeat) return setError('Пароли не совпадают');
    if (next.length < 8) return setError('Пароль должен быть не короче 8 символов');

    setBusy(true);
    setError(null);
    try {
      await api.post('/api/auth/change-password', {
        currentPassword: current,
        newPassword: next,
      });
      await reload();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось сменить пароль');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="h-full grid place-items-center px-4">
      <form onSubmit={submit} className="w-full max-w-[360px]">
        <div className="text-center mb-7">
          <div className="text-[24px] tracking-[0.01em] font-extrabold text-accent2">
            Конторка
          </div>
          <div className="text-lg font-bold mt-4">Придумай свой пароль</div>
          <div className="text-[12.5px] text-muted2 mt-2 leading-relaxed">
            Сейчас у тебя временный пароль, который знает администратор.
            Замени его — дальше он будет известен только тебе.
          </div>
        </div>

        <div className="card space-y-3">
          <div>
            <label className="label">Текущий пароль</label>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
            />
          </div>
          <div>
            <label className="label">Новый пароль</label>
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              placeholder="минимум 8 символов"
              value={next}
              onChange={(e) => setNext(e.target.value)}
            />
          </div>
          <div>
            <label className="label">Ещё раз</label>
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              value={repeat}
              onChange={(e) => setRepeat(e.target.value)}
            />
          </div>

          {error && (
            <div className="text-[12.5px] text-dang bg-dang/10 rounded-lg px-3 py-2 leading-snug">
              {error}
            </div>
          )}

          <button className="btn btn-primary w-full py-3" disabled={busy}>
            {busy ? 'Сохраняю…' : 'Сохранить и войти'}
          </button>
        </div>

        <div className="text-center text-[11.5px] text-muted2 mt-5">
          Вошёл как {user?.displayName}
          {' · '}
          <button type="button" className="hover:text-dang" onClick={() => void logout()}>
            выйти
          </button>
        </div>
      </form>
    </div>
  );
}
